// src/components/SmileSection.js
import React, { useEffect, useRef, useState } from 'react';

const SmileSection = () => {

    return (
    <div className="WordSection1 container">
        <p className="MsoNormal">
        <span lang="EN-GB">&nbsp;</span>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS SITE
        </span>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            <br />
            <b>What's in these terms?</b>
        </span>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            <br />
            These terms tell you the rules for using our website www.alignar.com
            (our site).&nbsp;
            <br />
            <br />
            Click on the links below to go straight to more information on each
            area:&nbsp;
            <br />
            <br />
            • Who we are and how to contact us.&nbsp;
            <br />
            <br />
            • By using our site you accept these terms.&nbsp;
            <br />
            <br />
            • There are other terms that may apply to you.&nbsp;
            <br />
            <br />
            • We may make changes to these terms.&nbsp;
            <br />
            <br />
            • We may make changes to our site.&nbsp;
            <br />
            <br />
            • We may suspend or withdraw our site.&nbsp;
            <br />
            <br />
            • We may transfer this agreement to someone else.&nbsp;
            <br />
            <br />
            • You must keep your account details safe.&nbsp;
            <br />
            <br />
            • How you may use material on our site.&nbsp;
            <br />
            <br />
            • Do not rely on information on our site.&nbsp;
            <br />
            <br />
            • We are not responsible for websites we link to.&nbsp;
            <br />
            <br />
            • Our responsibility for loss or damage suffered by you.&nbsp;
            <br />
            <br />
            • How we may use your personal information.&nbsp;
            <br />
            <br />
            • We are not responsible for viruses and you must not introduce
            them.&nbsp;
            <br />
            <br />
            • Rules about linking to our site.&nbsp;
            <br />
            <br />
            • Which country's laws apply to any disputes?&nbsp;
            <br />
            <br />
            • Our trade marks are registered.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">Who we are and how to contact us</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            www.alignar.com is a site operated by K Liner UK Ltd ("We").&nbsp;
            <br />
            <br />
            We are registered in England and Wales under company number 15961140 and
            have our registered office at 43 Berkeley Square, London, England, W1J
            5AP. Our main trading address is 43 Berkeley Square, London, England,
            W1J 5AP. <br />
            We are a limited company.&nbsp;
            <br />
            <br />
            To contact us, please email info@alignar.com.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">By using our site you accept these terms</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            By using our site, you confirm that you accept these terms of use and
            that you agree to comply with them.&nbsp;
            <br />
            <br />
            If you do not agree to these terms, you must not use our site.&nbsp;
            <br />
            <br />
            We recommend that you print a copy of these terms for future
            reference.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">There are other terms that may apply to you</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            These terms of use refer to the following additional terms, which also
            apply to your use of our site:&nbsp;
            <br />
            <br />• Our&nbsp;
            <a href="https://smilefast.com/privacy_policy">
            <b>Privacy Policy</b>
            </a>
            &nbsp;. See further under How we may use your personal
            information.&nbsp;
            <br />
            <br />• Our&nbsp;
            <a href="https://smilefast.com/cookie-policy">
            <b>Cookie Policy</b>
            </a>
            &nbsp;, which sets out information about the cookies on our site.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">We may make changes to these terms</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            We amend these terms from time to time. Every time you wish to use our
            site, please check these terms to ensure you understand the terms that
            apply at that time.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">We may make changes to our site</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            We may update and change our site from time to time to reflect changes
            to our products, our users' needs and our business priorities. We will
            try to give you reasonable notice of any major changes.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">We may suspend or withdraw our site</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            Our site is made available free of charge.&nbsp;
            <br />
            <br />
            We do not guarantee that our site, or any content on it, will always be
            available or be uninterrupted. We may suspend or withdraw or restrict
            the availability of all or any part of our site for business and
            operational reasons. We will try to give you reasonable notice of any
            suspension or withdrawal.&nbsp;
            <br />
            <br />
            You are also responsible for ensuring that all persons who access our
            site through your internet connection are aware of these terms of use
            and other applicable terms and conditions, and that they comply with
            them.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">We may transfer this agreement to someone else</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            We may transfer our rights and obligations under these terms to another
            organisation. We will always tell you in writing if this happens and we
            will ensure that the transfer will not affect your rights under the
            contract.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">You must keep your account details safe</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            If you choose, or you are provided with, a user identification code,
            password or any other piece of information as part of our security
            procedures, you must treat such information as confidential. You must
            not disclose it to any third party.&nbsp;
            <br />
            <br />
            We have the right to disable any user identification code or password,
            whether chosen by you or allocated by us, at any time, if in our
            reasonable opinion you have failed to comply with any of the provisions
            of these terms of use.&nbsp;
            <br />
            <br />
            If you know or suspect that anyone other than you knows your user
            identification code or password, you must promptly notify us at
            info@alignar.com.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">How you may use material on our site</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            We are the owner or the licensee of all intellectual property rights in
            our site, and in the material published on it. Those works are protected
            by copyright laws and treaties around the world. All such rights are
            reserved.&nbsp;
            <br />
            <br />
            You may print off one copy, and may download extracts, of any page(s)
            from our site for your personal use and you may draw the attention of
            others within your organisation to content posted on our site.&nbsp;
            <br />
            <br />
            You must not modify the paper or digital copies of any materials you
            have printed off or downloaded in any way, and you must not use any
            illustrations, photographs, video or audio sequences or any graphics
            separately from any accompanying text.&nbsp;
            <br />
            <br />
            Our status (and that of any identified contributors) as the authors of
            content on our site must always be acknowledged (except where the
            content is user-generated).&nbsp;
            <br />
            <br />
            You must not use any part of the content on our site for commercial
            purposes without obtaining a licence to do so from us or our
            licensors.&nbsp;
            <br />
            <br />
            If you print off, copy, download, share or repost any part of our site
            in breach of these terms of use, your right to use our site will cease
            immediately and you must, at our option, return or destroy any copies of
            the materials you have made.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">No text or data mining, or web scraping</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            You shall not conduct, facilitate, authorise or permit any text or data
            mining or web scraping in relation to our site or any services provided
            via, or in relation to, our site. This includes using (or permitting,
            authorising or attempting the use of):&nbsp;
            <br />
            <br />
            • Any "robot", "bot", "spider", "scraper" or other automated device,
            program, tool, algorithm, code, process or methodology to access,
            obtain, copy, monitor or republish any portion of the site or any data,
            content, information or services accessed via the same.&nbsp;
            <br />
            <br />
            • Any automated analytical technique aimed at analysing text and data in
            digital form to generate information which includes but is not limited
            to patterns, trends and correlations.&nbsp;
            <br />
            <br />
            The provisions in this clause should be treated as an express
            reservation of our rights in this regard, including for the purposes of
            Article 4(3) of Digital Copyright Directive ((EU) 2019/790).&nbsp;
            <br />
            <br />
            This clause shall not apply insofar as (but only to the extent that) we
            are unable to exclude or limit text or data mining or web scraping
            activity by contract under the laws which are applicable to us.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">Do not rely on information on this site</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            The content on our site is provided for general information only. It is
            not intended to amount to advice on which you should rely. You must
            obtain professional or specialist advice before taking, or refraining
            from, any action on the basis of the content on our site.&nbsp;
            <br />
            <br />
            Although we make reasonable efforts to update the information on our
            site, we make no representations, warranties or guarantees, whether
            express or implied, that the content on our site is accurate, complete
            or up to date.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">We are not responsible for websites we link to</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            Where our site contains links to other sites and resources provided by
            third parties, these links are provided for your information only. Such
            links should not be interpreted as approval by us of those linked
            websites or information you may obtain from them.&nbsp;
            <br />
            <br />
            We have no control over the contents of those sites or resources.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">
            Our responsibility for loss or damage suffered by you
            </span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">Whether you are a consumer or a business user:</span>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            • We do not exclude or limit in any way our liability to you where it
            would be unlawful to do so. This includes liability for death or
            personal injury caused by our negligence or the negligence of our
            employees, agents or subcontractors and for fraud or fraudulent
            misrepresentation.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">If you are a business user:</span>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            • We exclude all implied conditions, warranties, representations or
            other terms that may apply to our site or any content on it.&nbsp;
            <br />
            <br />
            • We will not be liable to you for any loss or damage, whether in
            contract, tort (including negligence), breach of statutory duty, or
            otherwise, even if foreseeable, arising under or in connection
            with:&nbsp;
            <br />
            <br />
            • use of, or inability to use, our site; or&nbsp;
            <br />
            <br />
            • use of or reliance on any content displayed on our site.&nbsp;
            <br />
            <br />
            • In particular, we will not be liable for:&nbsp;
            <br />
            <br />
            • loss of profits, sales, business, or revenue;&nbsp;
            <br />
            <br />
            • business interruption;&nbsp;
            <br />
            <br />
            • loss of anticipated savings;&nbsp;
            <br />
            <br />
            • loss of business opportunity, goodwill or reputation; or&nbsp;
            <br />
            <br />
            • any indirect or consequential loss or damage.&nbsp;
            <br />
            <br />
            If you are a consumer user:&nbsp;
            <br />
            <br />
            • Please note that we only provide our site for domestic and private
            use. You agree not to use our site for any commercial or business
            purposes, and we have no liability to you for any loss of profit, loss
            of business, business interruption, or loss of business
            opportunity.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">How we may use your personal information</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            We will only use your personal information as set out in our&nbsp;
            <a href="https://smilefast.com/privacy_policy">
            <b>Privacy Policy</b>
            </a>
            .&nbsp;
            <br />
            <br />
            We are not responsible for viruses and you must not introduce them&nbsp;
            <br />
            <br />
            We do not guarantee that our site will be secure or free from bugs or
            viruses.&nbsp;
            <br />
            <br />
            You are responsible for configuring your information technology,
            computer programmes and platform to access our site. You should use your
            own virus protection software.&nbsp;
            <br />
            <br />
            You must not misuse our site by knowingly introducing viruses, trojans,
            worms, logic bombs or other material that is malicious or
            technologically harmful. You must not attempt to gain unauthorised
            access to our site, the server on which our site is stored or any
            server, computer or database connected to our site. You must not attack
            our site via a denial-of-service attack or a distributed denial-of
            service attack. By breaching this provision, you would commit a criminal
            offence under the Computer Misuse Act 1990. We will report any such
            breach to the relevant law enforcement authorities and we will
            co-operate with those authorities by disclosing your identity to them.
            In the event of such a breach, your right to use our site will cease
            immediately.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">Rules about linking to our site</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            You may link to our home page, provided you do so in a way that is fair
            and legal and does not damage our reputation or take advantage of
            it.&nbsp;
            <br />
            <br />
            You must not establish a link in such a way as to suggest any form of
            association, approval or endorsement on our part where none
            exists.&nbsp;
            <br />
            <br />
            You must not establish a link to our site in any website that is not
            owned by you.&nbsp;
            <br />
            <br />
            Our site must not be framed on any other site, nor may you create a link
            to any part of our site other than the home page.&nbsp;
            <br />
            <br />
            We reserve the right to withdraw linking permission without
            notice.&nbsp;
            <br />
            <br />
            If you wish to link to or make any use of content on our site other than
            that set out above, please contact us.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">Which country's laws apply to any disputes?</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            If you are a consumer, please note that these terms of use, their
            subject matter and their formation, are governed by English law. You and
            we both agree that the courts of England and Wales will have exclusive
            jurisdiction except that if you are a resident of Northern Ireland you
            may also bring proceedings in Northern Ireland, and if you are resident
            of Scotland, you may also bring proceedings in Scotland.&nbsp;
            <br />
            <br />
            If you are a business, these terms of use, their subject matter and
            their formation (and any non-contractual disputes or claims) are
            governed by English law. We both agree to the exclusive jurisdiction of
            the courts of England and Wales.&nbsp;
            <br />
            <br />
            <br />
        </span>
        </p>
        <p className="MsoNormal">
        <b>
            <span lang="EN-GB">Our trade marks are registered</span>
        </b>
        </p>
        <p className="MsoNormal">
        <span lang="EN-GB">
            “Alignar” is a UK registered trade mark and the logo is a trade mark of
            K Liner UK Ltd. You are not permitted to use them without our approval,
            unless they are part of material you are using as permitted under How
            you may use material on our site.
        </span>
        </p>
    </div>

    );
};

export default SmileSection;
